export const linkButton = {
  tooltip: 'Accesează',
  ariaLabel: 'Accesează'
}
